var map = {
	"./Keyword/KeywordPage": 2715,
	"./Keyword/KeywordPage.vue": 2715,
	"./Product/Detail/Description": 526,
	"./Product/Detail/Description.vue": 526,
	"./Product/Detail/DetailPage": 9727,
	"./Product/Detail/DetailPage.vue": 9727,
	"./Product/Detail/DetailTikTokPage": 8533,
	"./Product/Detail/DetailTikTokPage.vue": 8533,
	"./Product/Detail/DetailViralPage": 1617,
	"./Product/Detail/DetailViralPage.vue": 1617,
	"./Product/Detail/Gallery": 1075,
	"./Product/Detail/Gallery.vue": 1075,
	"./Product/Detail/TikTokVideo": 5,
	"./Product/Detail/TikTokVideo.vue": 5,
	"./Product/Detail/ViralDescription": 6011,
	"./Product/Detail/ViralDescription.vue": 6011,
	"./Product/GuestProductBox": 6672,
	"./Product/GuestProductBox.vue": 6672,
	"./Product/GuestProductList": 8905,
	"./Product/GuestProductList.vue": 8905,
	"./Product/GuestProductViral": 7289,
	"./Product/GuestProductViral.vue": 7289,
	"./Product/ProductBox": 6905,
	"./Product/ProductBox.vue": 6905,
	"./Product/ProductList": 5147,
	"./Product/ProductList.vue": 5147,
	"./Product/ProductSaved": 8969,
	"./Product/ProductSaved.vue": 8969,
	"./Product/ProductTikTok": 9811,
	"./Product/ProductTikTok.vue": 9811,
	"./Product/ProductViral": 6686,
	"./Product/ProductViral.vue": 6686,
	"./Product/components/Bookmark": 4045,
	"./Product/components/Bookmark.vue": 4045,
	"./Product/components/Box": 6382,
	"./Product/components/Box.vue": 6382,
	"./Product/components/GoogleTrend": 102,
	"./Product/components/GoogleTrend.vue": 102,
	"./Product/components/InfoBox": 8827,
	"./Product/components/InfoBox.vue": 8827,
	"./Product/components/InfoRating": 818,
	"./Product/components/InfoRating.vue": 818,
	"./Product/components/List": 7867,
	"./Product/components/List.vue": 7867,
	"./Product/components/ListViral": 2333,
	"./Product/components/ListViral.vue": 2333,
	"./Product/components/Notice": 2902,
	"./Product/components/Notice.vue": 2902,
	"./Product/components/PageLoading": 252,
	"./Product/components/PageLoading.vue": 252,
	"./Product/components/ProductRecordNotFound": 1702,
	"./Product/components/ProductRecordNotFound.vue": 1702,
	"./Product/components/TikTokBox": 3879,
	"./Product/components/TikTokBox.vue": 3879,
	"./Product/components/TrendingProductUpdateTrendNotice": 4980,
	"./Product/components/TrendingProductUpdateTrendNotice.vue": 4980,
	"./Product/components/ViralProductUpdateTrendNotice": 3192,
	"./Product/components/ViralProductUpdateTrendNotice.vue": 3192,
	"./Product/components/WinningProductUpdateTrendNotice": 9482,
	"./Product/components/WinningProductUpdateTrendNotice.vue": 9482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3510;